export const forgotPasswordTranslations = {
  en: {
    resetPassword: "Reset Password",
    username: "Username",
    sendButton: "Send",
    discardButton: "Discard",
    emailSent: "Email has been sent!",
    emailSentMessage:
      "We have sent a password reset email if the username you entered exists in our system. Please check your inbox.",
    loginButton: "Login",
  },
  cz: {
    resetPassword: "Obnovit heslo",
    username: "Uživatelské jméno",
    sendButton: "Odeslat",
    discardButton: "Zrušit",
    emailSent: "Email byl odeslaný!",
    emailSentMessage:
      "Pokud zadané uživatelské jméno v našem systému existuje, odeslali jsme e-mail pro obnovení hesla. Zkontrolujte prosím svou doručenou poštu.",
    loginButton: "Přihlásit se",
  },
  ru: {
    resetPassword: "Сбросить пароль",
    username: "Имя пользователя",
    sendButton: "Отправить",
    discardButton: "Отменить",
    emailSent: "Письмо отправлено!",
    emailSentMessage:
      "Мы отправили письмо для сброса пароля, если введенное вами имя пользователя существует в нашей системе. Пожалуйста, проверьте вашу почту.",
    loginButton: "Войти",
  },
  fr: {
    resetPassword: "Réinitialiser le mot de passe",
    username: "Nom d'utilisateur",
    sendButton: "Envoyer",
    discardButton: "Annuler",
    emailSent: "Email a été envoyé!",
    emailSentMessage:
      "Nous avons envoyé un email de réinitialisation de mot de passe si le nom d'utilisateur que vous avez entré existe dans notre système. Veuillez vérifier votre boîte de réception.",
    loginButton: "Connexion",
  },
  es: {
    resetPassword: "Restablecer la contraseña",
    username: "Nombre de usuario",
    sendButton: "Enviar",
    discardButton: "Descartar",
    emailSent: "¡Correo electrónico ha sido enviado!",
    emailSentMessage:
      "Hemos enviado un correo electrónico de restablecimiento de contraseña si el nombre de usuario que ingresaste existe en nuestro sistema. Por favor, revise su bandeja de entrada.",
    loginButton: "Iniciar sesión",
  },
  nl: {
    resetPassword: "Wachtwoord opnieuw instellen",
    username: "Gebruikersnaam",
    sendButton: "Verzenden",
    discardButton: "Annuleren",
    emailSent: "Email is verzonden!",
    emailSentMessage:
      "We hebben een e-mail voor het opnieuw instellen van het wachtwoord verzonden als de gebruikersnaam die u hebt ingevoerd in ons systeem bestaat. Controleer uw inbox.",
    loginButton: "Inloggen",
  },
  sk: {
    resetPassword: "Obnoviť heslo",
    username: "Používateľské meno",
    sendButton: "Poslať",
    discardButton: "Zrušiť",
    emailSent: "Email bol odoslaný!",
    emailSentMessage:
      "Poslali sme email na obnovenie hesla, ak meno používateľa, ktoré ste zadali, existuje v našom systéme. Skontrolujte si svoju doručenú poštu.",
    loginButton: "Prihlásiť sa",
  },
  de: {
    resetPassword: "Passwort zurücksetzen",
    username: "Benutzername",
    sendButton: "Senden",
    discardButton: "Verwerfen",
    emailSent: "Email wurde gesendet!",
    emailSentMessage:
      "Wir haben eine Passwort-Zurücksetzen-Email gesendet, wenn der Benutzername, den Sie eingegeben haben, in unserem System existiert. Bitte überprüfen Sie Ihren Posteingang.",
    loginButton: "Anmelden",
  },
  hu: {
    resetPassword: "Jelszó visszaállítása",
    username: "Felhasználónév",
    sendButton: "Küldés",
    discardButton: "Elvetés",
    emailSent: "Email elküldve!",
    emailSentMessage:
      "Elküldtük a jelszó-visszaállító emailt, ha az általad megadott felhasználónév létezik a rendszerünkben. Kérjük, ellenőrizd a beérkező leveleidet.",
    loginButton: "Bejelentkezés",
  },
  pl: {
    resetPassword: "Zresetuj hasło",
    username: "Nazwa użytkownika",
    sendButton: "Wyślij",
    discardButton: "Anuluj",
    emailSent: "Email został wysłany!",
    emailSentMessage:
      "Wysłaliśmy email do zresetowania hasła, jeśli nazwa użytkownika, którą podałeś, istnieje w naszym systemie. Proszę sprawdzić skrzynkę odbiorczą.",
    loginButton: "Zaloguj się",
  },
  sv: {
    resetPassword: "Återställ lösenord",
    username: "Användarnamn",
    sendButton: "Skicka",
    discardButton: "Kassera",
    emailSent: "E-postmeddelandet har skickats!",
    emailSentMessage:
      "Vi har skickat ett e-postmeddelande för att återställa lösenordet om det användarnamn du angav finns i vårt system. Vänligen kontrollera din inkorg.",
    loginButton: "Logga in",
  },
  no: {
    resetPassword: "Tilbakestill passord",
    username: "Brukernavn",
    sendButton: "Send",
    discardButton: "Forkast",
    emailSent: "E-posten har blitt sendt!",
    emailSentMessage:
      "Vi har sendt en e-post for tilbakestilling av passord hvis brukernavnet du skrev inn finnes i vårt system. Vennligst sjekk innboksen din.",
    loginButton: "Logg inn",
  },
  da: {
    resetPassword: "Nulstil adgangskode",
    username: "Brugernavn",
    sendButton: "Send",
    discardButton: "Kassér",
    emailSent: "Emailen er blevet sendt!",
    emailSentMessage:
      "Vi har sendt en email til nulstilling af adgangskoden, hvis det brugernavn, du indtastede, findes i vores system. Tjek venligst din indbakke.",
    loginButton: "Log ind",
  },
  fi: {
    resetPassword: "Palauta salasana",
    username: "Käyttäjätunnus",
    sendButton: "Lähetä",
    discardButton: "Hylkää",
    emailSent: "Sähköposti on lähetetty!",
    emailSentMessage:
      "Olemme lähettäneet sähköpostin salasanan palauttamiseksi, jos antamasi käyttäjätunnus on olemassa järjestelmässämme. Tarkista postilaatikkosi.",
    loginButton: "Kirjaudu sisään",
  },
  ar: {
    resetPassword: "إعادة تعيين كلمة المرور",
    username: "اسم المستخدم",
    sendButton: "إرسال",
    discardButton: "تجاهل",
    emailSent: "تم إرسال البريد الإلكتروني!",
    emailSentMessage:
      "لقد أرسلنا بريدًا إلكترونيًا لإعادة تعيين كلمة المرور إذا كان اسم المستخدم الذي أدخلته موجودًا في نظامنا. يرجى التحقق من صندوق الوارد الخاص بك.",
    loginButton: "تسجيل الدخول",
  },
};

export default forgotPasswordTranslations;
